import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbwTestLayoutWidgetComponent } from './dbw-test-layout-widget/dbw-test-layout-widget.component';
import { SharedModule } from '@shared/shared.module';


@NgModule({
  declarations: [DbwTestLayoutWidgetComponent],
  exports: [DbwTestLayoutWidgetComponent],
  imports: [
    CommonModule,
    SharedModule 
  ]
})
export class DbwLayoutTestWidgetModule { }
